

import axios from "axios";
import { useMutation, useQueryClient } from "react-query";
import { LoginContext } from "contexts/LoginContext";
import { useContext } from "react";
import {configUrl} from "config.js";

export default function useSetMandatory() {
  let queryClient = useQueryClient();

  const {user} = useContext(LoginContext)

  return useMutation(
    async ({ id, questionId, mandatory }) => {
      await axios.put(`${configUrl.AssessmentServer}/api/PoolQuestionMappings/mandatory/${id}/${questionId}/${mandatory}/${user}`);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("questionsByPoolId");
      },
    }
  );
}


